module.exports = __webpack_public_path__ + "static/media/resume.a4d0f89d.pdf";